import { render, staticRenderFns } from "./HowToUse4.vue?vue&type=template&id=6e12613f&"
import script from "./HowToUse4.vue?vue&type=script&lang=js&"
export * from "./HowToUse4.vue?vue&type=script&lang=js&"
import style0 from "./HowToUse4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports